import DeleteIcon from '@/fsd/shared/ui/icons/Delete.jsx';
import React, { useEffect, useRef } from 'react';

interface SavePresetModalProps {
  value: string;
  onChange: (val: string) => void;
  onSave: () => void;
  onCancel: () => void;
  onDelete?: () => void;
  isEdit?: boolean;
}

export const SavePresetModal: React.FC<SavePresetModalProps> = ({
  value,
  onChange,
  onSave,
  onCancel,
  onDelete,
  isEdit = false,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: PointerEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onCancel();
      }
    };
    document.addEventListener('pointerdown', handleClick);
    return () => document.removeEventListener('pointerdown', handleClick);
  }, [onCancel]);


  return (
    <div
      ref={ref}
      style={{
        background: '#fff',
        borderRadius: 6,
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
        padding: 10,
        maxWidth: 250,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        zIndex: 9999,
      }}
    >
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder=""
        style={{
          border: 'none',
          borderBottom: '2px solid #429EFF',
          outline: 'none',
          fontFamily: 'Inter, sans-serif',
          fontSize: 16,
          padding: '4px 0 8px 4px',
          background: 'transparent',
        }}
        autoFocus
      />
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <button
          style={{
            flex: 1,
            background: '#429EFF',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            padding: '10px 0',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: 12,
            cursor: 'pointer',
            display: 'block',
          }}
          onClick={onSave}
        >
          Сохранить фильтр
        </button>
        <button
          style={{
            background: '#FFF',
            border: '1px solid #DCE7F1',
            borderRadius: 4,
            padding: 8,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
          }}
          onClick={isEdit && onDelete ? onDelete : onCancel}
          tabIndex={-1}
        >
          <DeleteIcon />
        </button>
      </div>
    </div>
  );
};
